import styled from "styled-components";
import UploadUnitDocumentNotificationsComponents from "../documentHandler/UploadUnitDocumentNotificationComponents";
import UploadUnitNotificationsComponents from "../documentHandler/UploadUnitNotificationsComponents";
import type { DocumentRegistrationDetails } from "../../../models/InvoiceModels";
import BodySmall from "../../atoms/typography/BodySmall";
import { HorizontalSpacer } from "../../atoms/Spacers";
import { Row } from "react-grid-system";
import ChevronButton from "../../atoms/buttons/ChevronButtons";
import { useState } from "react";
import { SlideOutHeight } from "../../atoms/SlideOutHeight";

interface Props {
  documentRegistrationDetails: DocumentRegistrationDetails;
  titleComponent?: React.ReactNode;
  expandable?: boolean;
}

const TagGridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
`;

const InvoiceDocumentTagCloud: React.FC<Props> = ({
  documentRegistrationDetails,
  titleComponent,
  expandable,
}) => {
  const [isOpen, setIsOpen] = useState(!expandable);

  return (
    <div>
      <Row nogutter justify="between" align="center">
        {titleComponent || (
          <BodySmall fontweight={500}>Data från uppladdningen:</BodySmall>
        )}
        {expandable && (
          <ChevronButton
            type={isOpen ? "up" : "down"}
            onClick={() => setIsOpen(!isOpen)}
          />
        )}
      </Row>

      <SlideOutHeight isVisible={isOpen}>
        <HorizontalSpacer spacing={0.5} />
        <TagGridContainer>
          {documentRegistrationDetails?.invoiceUploadUnit?.emailDetails && (
            <UploadUnitNotificationsComponents
              type="mail"
              emailContent={
                documentRegistrationDetails.invoiceUploadUnit.emailDetails
              }
            />
          )}
          {documentRegistrationDetails?.invoiceUploadUnit?.isBlacklisted && (
            <UploadUnitNotificationsComponents type="blacklist" />
          )}
          {documentRegistrationDetails?.userMessage && (
            <UploadUnitDocumentNotificationsComponents
              type="customerComment"
              comment={documentRegistrationDetails.userMessage}
            />
          )}

          {documentRegistrationDetails?.invoiceRecipientEmails &&
            documentRegistrationDetails.invoiceRecipientEmails.length > 0 && (
              <UploadUnitDocumentNotificationsComponents
                type="recipientAddress"
                recipientEmails={
                  documentRegistrationDetails.invoiceRecipientEmails
                }
              />
            )}
          {documentRegistrationDetails?.invoiceRecipientGln && (
            <UploadUnitDocumentNotificationsComponents
              type="gln"
              gln={documentRegistrationDetails.invoiceRecipientGln}
            />
          )}
          {documentRegistrationDetails?.comments &&
            documentRegistrationDetails.comments?.totalCount > 0 && (
              <UploadUnitDocumentNotificationsComponents
                type="comments"
                comments={documentRegistrationDetails.comments?.items}
              />
            )}
          {documentRegistrationDetails?.serviceType === "ADMINISTER_INVOICE" ? (
            <UploadUnitDocumentNotificationsComponents type="serviceAdmin" />
          ) : (
            <UploadUnitDocumentNotificationsComponents type="serviceFinance" />
          )}
        </TagGridContainer>
      </SlideOutHeight>
    </div>
  );
};

export default InvoiceDocumentTagCloud;
